/**
 * Extrai texto de PDF no navegador (evita enviar o binário na API — limite ~10 MB).
 * Ordena itens por posição (topo→baixo, esquerda→direita) para fluxogramas visuais.
 */
let pdfjsReady;

async function getPdfJs() {
  if (pdfjsReady) return pdfjsReady;
  const pdfjs = await import("pdfjs-dist/legacy/build/pdf.mjs");
  const version = pdfjs.version || "5.4.296";
  pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${version}/legacy/build/pdf.worker.min.mjs`;
  pdfjsReady = pdfjs;
  return pdfjs;
}

const LINE_Y_TOLERANCE = 6;

function pageTextFromContent(content) {
  const items = (content?.items || [])
    .filter((item) => typeof item.str === "string" && item.str.trim())
    .map((item) => ({
      str: item.str,
      x: item.transform?.[4] ?? 0,
      y: item.transform?.[5] ?? 0,
    }));

  if (!items.length) return "";

  items.sort((a, b) => {
    const yDiff = b.y - a.y;
    if (Math.abs(yDiff) > LINE_Y_TOLERANCE) return yDiff;
    return a.x - b.x;
  });

  const lines = [];
  let bucket = [];
  let lastY = null;

  for (const item of items) {
    if (lastY !== null && Math.abs(item.y - lastY) > LINE_Y_TOLERANCE) {
      if (bucket.length) {
        lines.push(bucket.map((i) => i.str).join(" ").replace(/\s+/g, " ").trim());
        bucket = [];
      }
    }
    bucket.push(item);
    lastY = item.y;
  }
  if (bucket.length) {
    lines.push(bucket.map((i) => i.str).join(" ").replace(/\s+/g, " ").trim());
  }

  return lines.filter(Boolean).join("\n");
}

export async function extractPdfTextFromFile(file, { onProgress } = {}) {
  if (!file) throw new Error("no_file");
  const pdfjs = await getPdfJs();
  const data = new Uint8Array(await file.arrayBuffer());
  const task = pdfjs.getDocument({ data, useSystemFonts: true });
  const pdf = await task.promise;
  const parts = [];
  const total = pdf.numPages || 0;

  for (let pageNum = 1; pageNum <= total; pageNum += 1) {
    const page = await pdf.getPage(pageNum);
    const content = await page.getTextContent();
    const pageText = pageTextFromContent(content);
    if (pageText) parts.push(pageText);
    onProgress?.(pageNum, total);
  }

  await pdf.destroy?.();

  const text = parts.join("\n\n").trim();
  if (!text || text.length < 20) {
    throw new Error("insufficient_text");
  }
  return text;
}
